import React, { useState, useRef, useMemo } from 'react';
import JoditEditor from 'jodit-react';

// import  React from 'react';
// import { Editor } from '@tinymce/tinymce-react';

// const WysiwygEditor = ({ input: { value, onChange }}) => (
//     <Editor
//       apiKey='24dxyh64zx5l9jfph18dyiebyr096auof556i073e1rcifqb'
//       initialValue={value}
//       init={{
//         height: 800,
//         language: 'ru',
//         menubar: false,
//         plugins: [
//           'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
//           'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
//           'insertdatetime', 'media', 'table', 'code', 'help', 'wordcount'
//         ],
//         toolbar: 'undo redo | blocks | ' +
//           'bold italic forecolor | alignleft aligncenter ' +
//           'alignright alignjustify | bullist numlist outdent indent | ' +
//           'removeformat | help',
//         // content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
//       }}
//       onEditorChange={onChange}
//     />
//   );


const WysiwygEditor = ({ input: { value, onChange }}) => {
	const editor = useRef(null);
	const [content] = useState(value);

	const config = useMemo(
		() => ({
			readonly: false, // all options from https://xdsoft.net/jodit/docs/,
			placeholder: value || '',
			minHeight: 600
		}),
		[value]
	);

	return (
		<div style={{paddingTop: 16}}>
			<JoditEditor
				ref={editor}
				value={content}
				config={config}
				tabIndex={1} // tabIndex of textarea
				onBlur={(newContent) => onChange(newContent)} // preferred to use only this option to update the content for performance reasons
				// onChange={onChange}
			/>
		</div>
	);
};


export default WysiwygEditor;